import { OfferPageScreen } from './offer-page-status.model';

// Shown instead of the advisor's own address when no advisor is assigned. Not brand-aware:
// CompanyBranding carries no sales address, so a LevelEsq applicant sees this one.
export const OFFER_PAGE_FALLBACK_EMAIL = 'sales@ideafinancial.com';

// Used only for the window before BrandingService emits, and if its request fails outright —
// otherwise the copy renders a literal "undefined" and an empty phone on an anonymous page.
// Same defaults the rest of the app already falls back to: app.component.ts:51 (company name)
// and common's app-bar-contact.component.ts:55 (phone).
export const OFFER_PAGE_FALLBACK_COMPANY_NAME = 'Idea Financial';
export const OFFER_PAGE_FALLBACK_PHONE = '1 (855) 900-7838';

export interface OfferPageStatusData {
  heading: string;
  body: string;
  showApplyCta: boolean;
  showProcessingDots: boolean;
}

// Copy is verbatim from the approved Figma frames (page 4699:2786), U+2019 apostrophes included.
export function getOfferPageStatusData(screen: OfferPageScreen, companyName: string): OfferPageStatusData {
  switch (screen) {
    case OfferPageScreen.Processing:
      return {
        heading: 'Your application is still processing',
        // eslint-disable-next-line max-len
        body: 'We’re still reviewing your application and don’t have an offer ready just yet. Please check back later for an update.',
        showApplyCta: false,
        showProcessingDots: true
      };
    case OfferPageScreen.OfferExpired:
      return {
        heading: 'Your offer has expired',
        // eslint-disable-next-line max-len
        body: 'This offer is no longer available. Please contact your Business Advisor to discuss your financing options and next steps.',
        showApplyCta: false,
        showProcessingDots: false
      };
    case OfferPageScreen.LookingForFinancing:
      return {
        heading: 'Looking for financing?',
        body: 'Submit a new application to explore financing options that may be available to you.',
        showApplyCta: true,
        showProcessingDots: false
      };
    case OfferPageScreen.UnableToFund:
      return {
        heading: 'We’re unable to fund your application',
        // The Figma names Idea Financial literally; this app serves both brands, so the lender
        // name comes from branding.dba.
        // eslint-disable-next-line max-len
        body: `Thank you for your interest in ${companyName} and for taking the time to submit an application. At this time, we’re unable to approve your application.`,
        showApplyCta: false,
        showProcessingDots: false
      };
    case OfferPageScreen.FullOffer:
      return null;
  }
}
